<template>
    <isc-popover v-show="show" class="main-debug" :visible-arrow="false" :popper-class="$style.popper">
        <com-menu>
            <com-menu-item @click="onLicenseInvalid">触发 license:invalid</com-menu-item>
            <com-menu-item @click="onReplaceApp">替换</com-menu-item>
        </com-menu>

        <isc-button slot="reference" type="danger">DEBUG</isc-button>
    </isc-popover>
</template>

<script>
import { Popover } from '@isyscore/base-ui';
import Keyboard from '@isyscore/classes/keyboard';
import ComMenuItem from '../../common/com-menu-item.vue';
import ComMenu from '../../common/com-menu.vue';
import { receiveLicenseInvalid } from '../../desk-global/global-messenger/messenger.js';

export default {
    name: 'MainDebug',

    components: { ComMenuItem, ComMenu, IscPopover: Popover },

    data() {
        return {
            show: process.env.NODE_ENV !== 'production'
        };
    },

    mounted() {
        this.kb = new Keyboard();
        this.kb.bind(new Array(6).fill('d'), () => {
            this.show = !this.show;
        });
    },

    beforeDestroy() {
        this.kb.destroy();
    },

    methods: {
        onLicenseInvalid() {
            receiveLicenseInvalid();
        },
        onReplaceApp() {
            this.$appManager.replaceApp('system-manage', '/about-os');
        }
    }
};
</script>

<style lang="scss" scoped>
.main-debug {
    position: fixed;
    right: 20px;
    bottom: 20px;
    z-index: 999;
}
</style>

<style lang="scss" module>
.popper {
    background: transparent !important;
    border: 0 !important;
    padding: 0 !important;
}
</style>
